import { render, staticRenderFns } from "./evaluacion-indicadores-proceso-ver.vue?vue&type=template&id=ab759da0&"
import script from "./evaluacion-indicadores-proceso-ver.vue?vue&type=script&lang=js&"
export * from "./evaluacion-indicadores-proceso-ver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports